import { Injectable } from "@angular/core";

import { LastSuccessRegistrationStepData } from "./spid-register/spid-gtm.model";

@Injectable({ providedIn: "root" })
export class RegistrationStepsTrackerService {
	private readonly _lastSuccessRegistrationStepDataStorageKey = "lastSuccessRegistrationStep" as const;

	saveLastSuccessRegistrationStepDataToStorage(data: LastSuccessRegistrationStepData): void {
		sessionStorage.setItem(this._lastSuccessRegistrationStepDataStorageKey, JSON.stringify(data));
	}

	getLastSuccessRegistrationStepDataFromStorage(): LastSuccessRegistrationStepData | null {
		const data = sessionStorage.getItem(this._lastSuccessRegistrationStepDataStorageKey);
		let result: LastSuccessRegistrationStepData | null = null;

		try {
			result = data ? (JSON.parse(data) as LastSuccessRegistrationStepData) : null;
		} catch {
			console.error("Error while parsing last success registration step data from storage.");
		}

		return result;
	}

	eraseLastSuccessRegistrationStepDataFromStorage(): void {
		sessionStorage.removeItem(this._lastSuccessRegistrationStepDataStorageKey);
	}
}
